"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Support = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Support = function Support() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M21.6364 13.0909V17.4545C21.6364 18.6595 20.6595 19.6364 19.4545 19.6364V20.7273C19.4545 22.5348 17.9893 24 16.1818 24H12.9091C12.3066 24 11.8182 23.5116 11.8182 22.9091V22.3636C11.8182 22.0624 12.0624 21.8182 12.3636 21.8182H16.1818C16.7843 21.8182 17.2727 21.3298 17.2727 20.7273V19.6364C16.6702 19.6364 16.1818 19.1479 16.1818 18.5455V12C16.1818 11.3975 16.6702 10.9091 17.2727 10.9091V7.63636C17.2727 4.6239 14.8306 2.18182 11.8182 2.18182C8.80572 2.18182 6.36364 4.6239 6.36364 7.63636V10.9091C6.96613 10.9091 7.45455 11.3975 7.45455 12V18.5455C7.45455 19.1479 6.96613 19.6364 6.36364 19.6364H4.18182C2.97683 19.6364 2 18.6595 2 17.4545V13.0909C2 11.8859 2.97683 10.9091 4.18182 10.9091V7.63636C4.18182 3.41892 7.60074 0 11.8182 0C16.0356 0 19.4545 3.41892 19.4545 7.63636V10.9091C20.0332 10.9091 20.5882 11.139 20.9973 11.5481C21.4065 11.9573 21.6364 12.5123 21.6364 13.0909Z"
  });
};

exports.Support = Support;